import React from "react";
import "./rummy_round_history.css";
import "../RummyTableHistoryInnerRoundCards/RummyTableHistoryInnerRoundCards.css";
import "../RummyTableHistoryInnerRound/RummyTableHistoryInnerRound.css";
import { Modal } from "react-bootstrap";

function RummyRoundHistory(props) {
  return (
    <div className="Successfull_Modal_sec">
      <Modal
        className="Successfull_Modal rc-modal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Header closeButton>
          <Modal.Title>Rummy Round History</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="rummy-history-table-wrapper">
            <table className="rummy-history-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Round No</th>
                  <th>Points</th>
                  <th>Total Points</th>
                  <th>Remark</th>
                </tr>
              </thead>

              <tbody>
                {props?.rummyWalletHistory?.length > 0 ? (
                  props.rummyWalletHistory.map((item, index) => (
                    <tr key={item.id || index}>
                      <td>{index + 1}</td>
                      <td>{item.round_no || "-"}</td>
                      <td className="rc-loss-points">- {item.points ?? "-"}</td>
                      <td>{item.RummyGameHistory?.winning_point ?? "-"}</td>
                      <td>{item.win_loss ?? "-"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="no-history">
                      No round history found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default RummyRoundHistory;
